// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'
import { commodityCodePath, commodityCodeSegmentPath } from '../../routes/api'
import { api } from 'components/api'
import { debounce } from 'lodash-es'
import abbreviate from 'number-abbreviate'

class CommodityCodes extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      showMore: false,
      visibleSegments: this.props.commodityCodeSegments,
      searchTerm: ''
    }
  }

  handleSegChange = seg => {
    if (this.props.locked) return
    this.props.onSegChange(seg)
  }

  handleCommodityCodeSegmentChange = (segmentId, segmentTitle) => {
    if (this.props.locked) return
    if (this.props.selectedCommodityCodeSegmentId === segmentId) {
      this.props.onCommodityCodeSegmentChange({
        selectedCommodityCodeSegmentId: null,
        selectedCommodityCodeSegmentTitle: null,
        activeCommodityFamilies: [],
        seg: null,
        commodityCodes: []
      })
    } else {
      api.get({
        url: commodityCodePath(segmentId),
        headers: { Accept: 'application/json' }
      }).then((response) => {
        this.props.onCommodityCodeSegmentChange(
          {
            selectedCommodityCodeSegmentId: segmentId,
            selectedCommodityCodeSegmentTitle: segmentTitle,
            activeCommodityFamilies: response.data,
            seg: null,
            commodityCodes: []
          },
          true
        )
      })
    }
  }

  renderSegmentTitles = () => {
    let counter = 0
    const list =
      Object.entries(this.props.commodityCodeSegmentCount).map(([itemDescription, count]) => {
        if (this.state.visibleSegments[itemDescription]) {
          counter++
          const segmentId = this.props.commodityCodeSegments[itemDescription]
          return (
            <div
              className={`grid-x commodity-code pointer-clickable ${counter > 8 && !this.state.showMore ? 'hidden' : ''}`}
              onClick={() => {
                this.handleCommodityCodeSegmentChange(segmentId, itemDescription)
                this.handleSegChange(itemDescription)
              }}
              key={`segment-${segmentId}`}
            >
              <div className='cell auto'>
                {itemDescription}
              </div>
              <div className='cell shrink count'>
                {abbreviate(count, 1)}
              </div>
            </div>
          )
        }

        return undefined
      })

    let showMore = ''
    if (Object.keys(this.state.visibleSegments).length > 7) {
      const text = this.state.showMore ? 'See Less' : 'See More'
      const caret = this.state.showMore ? 'up' : 'down'
      showMore = <button className='color-pro-blue-500 pro-text-s' onClick={this.props.locked ? null : this.toggleShowMore}><i className={`far fa-angle-${caret}`} /> {text}</button>
    }

    return (
      <>
        {list}
        {showMore}
      </>
    )
  }

  toggleShowMore = () => {
    this.setState({ showMore: !this.state.showMore })
  }

  renderSegmentDetails = () => {
    return (
      <>
        <div
          className='grid-x active commodity-code-segment-subsection'
          onClick={() => this.handleCommodityCodeSegmentChange(this.props.selectedCommodityCodeSegmentId, null)}
        >
          <div className='cell small-1'>
            <i className='fal fa-angle-left active' />
          </div>
          <div className='cell small-11'>
            <h3>
              {this.props.selectedCommodityCodeSegmentTitle}
            </h3>
          </div>
        </div>
        <div className='grid-x commodity-code'>
          <div className='cell small-1' />
          <div className='cell small-11'>
            {this.renderFamilyCodes()}
          </div>
        </div>
      </>
    )
  }

  handleCommodityCodeChange = commodityCode => {
    if (this.props.locked) return
    let newCommodityCodes
    const commodityCodes = this.props.selectedCommodityCodes
    if (commodityCodes.includes(commodityCode)) {
      newCommodityCodes = commodityCodes.filter(c => c !== commodityCode)
    } else {
      newCommodityCodes = [...commodityCodes, commodityCode]
    }
    this.props.onCommodityCodeChange(newCommodityCodes)
  }

  renderFamilyCodes = () => {
    const families =
      Object.entries(this.props.commodityCodeFamilyCount).map(([itemDescription]) => {
        const commodityCodeFamily = this.props.activeCommodityFamilies.find(cc => cc.item_description === itemDescription)
        if (commodityCodeFamily) {
          return (
            <div
              onClick={() => this.handleCommodityCodeChange(commodityCodeFamily.item_description)}
              key={commodityCodeFamily.id}
              className={`grid-x commodity-code-family ${this.props.selectedCommodityCodes.includes(commodityCodeFamily.item_description) ? 'selected' : 'active'}`}
            >
              <div className='cell auto'>
                {commodityCodeFamily.item_description}
              </div>
              <div className='cell shrink count'>
                {this.props.commodityCodeFamilyCount[commodityCodeFamily.item_description]}
              </div>
            </div>
          )
        }

        return undefined
      })

    return <>{families}</>
  }

  handleSearchChange = (event) => {
    this.setState({ searchTerm: event.target.value })

    if (!this.debouncedSearchCommodityCodesFn) {
      this.debouncedSearchCommodityCodesFn = debounce((searchTerm) => {
        if (searchTerm.length > 2) {
          api.get({
            url: `${commodityCodeSegmentPath()}?search=${searchTerm}`,
            headers: {
              Accept: 'application/json'
            }
          }).then((response) => {
            this.setState({
              visibleSegments: response.data
            })
          })
        } else {
          this.setState({
            visibleSegments: this.props.commodityCodeSegments
          })
        }
      }, 300)
    }
    this.debouncedSearchCommodityCodesFn(event.target.value.trim())
  }

  handleSearchClear = () => {
    this.setState({
      searchTerm: '',
      visibleSegments: this.props.commodityCodeSegments
    })
  }

  render () {
    if (this.props.selectedCommodityCodeSegmentId) {
      return this.renderSegmentDetails()
    } else {
      return (
        <>
          <div className='grid-x commodity-code-search'>
            <div className='cell shrink'>
              <i className='fas fa-search search-icon' />
            </div>
            <div className='cell auto'>
              <input
                type='text'
                value={this.state.searchTerm}
                className='search-box'
                placeholder='Search product or service filters'
                onChange={this.handleSearchChange}
                disabled={this.props.locked}
              />
            </div>
            <div className='cell shrink'>
              <i
                className={`far fa-times clear-icon pointer-clickable ${this.state.searchTerm.length === 0 ? 'hide' : ''}`}
                onClick={this.handleSearchClear}
              />
            </div>
          </div>

          {this.renderSegmentTitles()}
        </>
      )
    }
  }
}

CommodityCodes.propTypes = {
  commodityCodeSegments: PropTypes.object.isRequired,
  commodityCodeSegmentCount: PropTypes.object.isRequired,
  activeCommodityFamilies: PropTypes.array.isRequired,
  commodityCodeFamilies: PropTypes.array.isRequired,
  commodityCodeFamilyCount: PropTypes.object.isRequired,
  onSegChange: PropTypes.func.isRequired,
  onCommodityCodeChange: PropTypes.func.isRequired,
  onCommodityCodeSegmentChange: PropTypes.func.isRequired,
  selectedCommodityCodeSegmentId: PropTypes.number,
  selectedCommodityCodeSegmentTitle: PropTypes.string,
  selectedCommodityCodes: PropTypes.array.isRequired,
  locked: PropTypes.bool
}

CommodityCodes.defaultProps = {
  selectedCommodityCodeSegmentId: null,
  selectedCommodityCodeSegmentTitle: null,
  locked: false
}

export default CommodityCodes
